"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChevronLeftIconSmall = ChevronLeftIconSmall;
exports.default = ChevronLeftIcon;
var _react = _interopRequireDefault(require("react"));
var _iconBase = _interopRequireDefault(require("./shared/icon-base"));
var _core = require("@emotion/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ChevronLeftIcon(props) {
  return (0, _core.jsx)(_iconBase.default, props, (0, _core.jsx)("path", {
    d: "M15.5521 20L7.46667 12L15.5521 4L16.8 5.44589L10.1762 12L16.8 18.5541L15.5521 20Z",
    fill: "currentColor"
  }));
}
function ChevronLeftIconSmall(props) {
  return (0, _core.jsx)(ChevronLeftIcon, _extends({
    size: "small"
  }, props));
}